/* Match the cart to the visible screen, including mobile browser controls. */
(() => {
  let scheduled = false;
  function measure() {
    scheduled = false;
    const viewport = window.visualViewport;
    const root = document.documentElement;
    const width = Math.floor(Math.min(root.clientWidth, window.innerWidth, viewport ? viewport.width : window.innerWidth));
    const height = Math.floor(viewport ? viewport.height : window.innerHeight);
    if (width <= 0 || height <= 0) return;
    root.style.setProperty('--tc-screen-width', width + 'px');
    root.style.setProperty('--tc-screen-height', height + 'px');
    root.style.setProperty('--tc-screen-left', (viewport ? viewport.offsetLeft : 0) + 'px');
    root.style.setProperty('--tc-screen-top', (viewport ? viewport.offsetTop : 0) + 'px');
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(measure);
  }
  measure();
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule, { passive: true });
    window.visualViewport.addEventListener('scroll', schedule, { passive: true });
  }
})();
